package com.shmbles.web.models

import com.shmbles.web.util.Constants.ANDROID_RESUME
import com.shmbles.web.util.Constants.ARCHITECTURE_PATTERN_RESUME
import com.shmbles.web.util.Constants.IOS_RESUME
import com.shmbles.web.util.Constants.METRICS_RESUME
import com.shmbles.web.util.Constants.TESTING_RESUME
import com.shmbles.web.util.Constants.TOOLS_RESUME
import com.shmbles.web.util.Res

enum class Service(
    val icon: String,
    val imageDesc: String,
    val title: String,
    val description: String
) {
    Android(
        icon = Res.Icon.android,
        imageDesc = "Android Icon",
        title = "Android Development",
        description = ANDROID_RESUME
    ),
    IOS(
        icon = Res.Icon.ios,
        imageDesc = "Apple Icon",
        title = "iOS Development",
        description = IOS_RESUME
    ),
    Architecture(
        icon = Res.Icon.architecture,
        imageDesc = "Architecture Icon",
        title = "Architecture and Patterns",
        description = ARCHITECTURE_PATTERN_RESUME
    ),
    Metrics(
        icon = Res.Icon.metrics,
        imageDesc = "Metrics Icon",
        title = "Metrics and Traceability",
        description = METRICS_RESUME
    ),
    Testing(
        icon = Res.Icon.testing,
        imageDesc = "Testing Icon",
        title = "Testing and Release",
        description = TESTING_RESUME
    ),
    Tools(
        icon = Res.Icon.tools,
        imageDesc = "Tools Icon",
        title = "Tools and Libraries",
        description = TOOLS_RESUME
    ),
}